import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player/lazy'

const VideoBox = ({ url, parameters, onVideoPlay = {}, aiStatus, element, renderAiOverlay = () => null }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setHasError(false);
    }, [url]);

    if (!url || typeof url !== 'string' || !url.trim() || url.trim() === 'null' || url.trim() === 'undefined') {
        return null;
    }

    const cleanUrl = url.trim();

    if (ReactPlayer.canPlay && !ReactPlayer.canPlay(cleanUrl)) {
        return null;
    }

    if (hasError) {
        return null;
    }

    return (
        <div>
            <ReactPlayer
                className='react-player'
                onPlay={onVideoPlay}
                onError={() => setHasError(true)}
                style={{
                    minHeight: "8rem",
                    maxHeight: "14rem"
                }}
                url={cleanUrl}
                width='100%'
                config={{
                    file: {
                        attributes: {
                            controlsList: 'nodownload'
                        }
                    }
                }}
                controls
                styles={{}}
                {...parameters}
            />
            {renderAiOverlay(aiStatus, element)}
        </div>
    )
}

export default React.memo(VideoBox)